import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/estimation/')({
  beforeLoad: () => {
    throw redirect({ to: '/estimation/new/basics/project' });
  },
});
